<div class="form-cards"
    *ngIf="participantInfo.caseEventHasEventFormsForParticipantsRole"
>
  <h2 [innerHTML]="participantInfo.renderedListItem|unsanitizeHtml"></h2>
  <div 
    class="new-form-container"
    *ngIf="participantInfo.eventFormsParticipantCanCreate && participantInfo.eventFormsParticipantCanCreate.length > 0"
  >
    <paper-fab 
      class="new-form-button"
      routerLink="{{participantInfo.newFormLink}}"
      icon="add"
    >
    </paper-fab>
  </div>
  <app-event-form-list-item
    *ngFor="let eventFormInfo of participantInfo.eventFormInfos"
    [case]="caseService.case"
    [caseDefinition]="caseService.caseDefinition"
    [caseEvent]="caseEvent"
    [caseEventDefinition]="caseEventDefinition"
    [eventForm]="eventFormInfo.eventForm"
    [eventFormDefinition]="eventFormInfo.eventFormDefinition"
    (formDeletedEvent)="onDeleteFormClick(eventFormInfo.eventForm.id)"
    (formArchivedEvent)="onArchiveFormClick(eventFormInfo.eventForm.id)"
    (formUnarchivedEvent)="onUnarchiveFormClick(eventFormInfo.eventForm.id)"
    class="form {{eventFormInfo.eventFormDefinition.required ? 'required' : ''}}" 
  >
  </app-event-form-list-item>
</div>